import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RepresentanteModalidadeComercialValue, getRepresentanteModalidadeComercial } from '../../../domain';

/** Styles do badge */
interface Styles {
    fontSize: string
}

/** Badge da modalidade comercial */
@Component({
    selector: 'sgt-representante-modalidade-comercial-badge',
    templateUrl: './representante-modalidade-comercial-badge.component.html',
    styleUrls: ['./representante-modalidade-comercial-badge.component.less']
})
export class RepresentanteModalidadeComercialBadgeComponent implements OnInit, OnChanges {
    /** Propriedades para o badge */
    @Input() modalidade: number;
    /** Styles personalizados do badge */
    @Input() styles: Styles = {
        fontSize: '75%'
    }

    /** Modalidade Comercial */
    value: RepresentanteModalidadeComercialValue;

    ngOnInit(): void {
        this.setValue();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['modalidade']) {
            this.setValue();
        }
    }

    /** Seta o value da modalidade comercial via input */
    private setValue() {
        this.value = getRepresentanteModalidadeComercial(this.modalidade);
    }
}
